import BaseApi from '@/api/BaseApi'

export default class OrganizationsSettingsApi extends BaseApi {
    async getOrganizationSettingsById (organizationId) {
        return this.get(`/api/v1.0/organizationsSettings/${organizationId}`)
    }

    async getOrganizatoinsProximitySettings (organizationId) {
        return this.get(`/api/v1.0/organizationsSettings/proximitySettings/${organizationId}`)
    }

    async getEventNotificationSettings (organizationId) {
        return this.get(`/api/v1.0/organizationsSettings/eventNotificationSettings/${organizationId}`)
    }

    async getDeviceNotificationSettings (organizationId) {
        return this.get(`/api/v1.0/organizationsSettings/deviceNotificationSettings/${organizationId}`)
    }

    async getOrganizationsAlarmPipelinesSettings (deviceModelId, organizationId = null) {
        const request = new URLSearchParams()
        if (organizationId) request.append('organizationId', organizationId)
        return this.get(`/api/v1.0/organizationsSettings/alarmsPipelinesSettings/${deviceModelId}`, request)
    }

    async createOrganizationsAlarmPipelinesSettings (params = {
        deviceModelId: null,
        organizationId: null,
        pipeline: {
            type: null,
            alarmKey: null,
            eventType: null,
            eventClassification: null,
            channels: null,
            isOverriding: null
        }
    }) {
        return this.post(`/api/v1.0/organizationsSettings/alarmsPipelinesSettings/`, params)
    }

    async updateOrganizationsSettings (params = {
        organizationId: null,
        settings: {
            snappedJourneys: null,
            journeyProcessingSettings: {
                journeyInterval: null
            },
            videoSettings: {
                overlaySpeedUnit: null,
                defaultVideoLength: null,
                maxVideoLength: null,
                allowPickVideoLength: null
            },
            idleSettings: {
                duration: null,
                speed: null,
                distance: null
            }
        }
    }) {
        return this.put('/api/v1.0/organizationsSettings', params)
    }

    async updateOrganizationsProximitySettings (params = {
        organizationId: null,
        emails: null
    }) {
        return this.put('/api/v1.0/organizationsSettings/proximitySettings', params)
    }

    async updateEventNotificationSettings (organizationId, settings) {
        return this.put('/api/v1.0/organizationsSettings/eventNotificationSettings', {
            organizationId,
            settings
        })
    }

    async updateDeviceNotificationSettings (settings) {
        return this.put('/api/v1.0/organizationsSettings/deviceNotificationSettings', {
            settings
        })
    }
    async resetOrganizationsAlarmPipelinesSettings (params = {
        alarmKey: null,
        deviceModelId: null,
        organizationId: null
    }) {
        return this.put('/api/v1.0/organizationsSettings/alarmsPipelinesSettings/reset', params)
    }

    async getOrganizationIntegrationSettings (organizationId) {
        return this.get(`/api/v1.0/organizationsSettings/integrationSettings/${organizationId}`)
    }

    async editOrganizationIntegrationSettings ({ organizationId, azureADTenantId }) {
        return this.put('/api/v1.0/organizationsSettings/integrationSettings', {
            organizationId,
            azureADTenantId
        })
    }
}
